import { License } from '@mprolab/sdk'
import { makeAutoObservable, observable, action } from 'mobx'

export enum ProgressState {
  INITIAL,
  PENDING,
  CONFIRMING,
  SUCCESS,
  ERROR
}

export class IncexNodeStore {
  constructor() {
    makeAutoObservable(this)
  }

  @observable
  node: License

  @observable
  accessToken: string

  @observable
  progress = ProgressState.INITIAL

  @observable
  isLoading = false

  @observable
  error = undefined

  @action
  setAccessToken(accessToken: string) {
    this.accessToken = accessToken
  }

  @action
  setProgress(progress: ProgressState) {
    this.progress = progress
  }

  @action
  setIsLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }

  @action
  setError(errorCode: any) {
    this.error = errorCode
  }

  @action
  setNode(node: License) {
    this.node = node
  }

  @action
  resetIndexNodeStore() {
    this.accessToken = undefined
    this.progress = ProgressState.INITIAL
    this.error = undefined
    this.isLoading = false
    this.node = undefined
  }
}

export const indexNodeStore = new IncexNodeStore()
